import MissionsAccordion from "src/scenes/dashboard/overview-components/missions-accordion";
import React, { useState } from "react";
import TeamMissionDeleteModal from "src/scenes/teams/team/team-mission-delete-modal";
import { useAuth } from "src/components/providers/auth-context";
import { useTeam } from "src/scenes/teams/team/team-provider";
import request from "src/utils/request";

const TeamMissionsTemplate = ({ teamId }) => {
    const [activeMissions, setActiveMissions] = useState([]);

    const [toDeleteId, setToDeleteId] = useState("");
    const [toDeleteKey, setToDeleteKey] = useState("");
    const [isMissionsModalOpen, setIsMissionModalOpen] = useState(false);
    const [isMissionsDeleteModalOpen, setIsMissionDeleteModalOpen] = useState(false);

    const { isDemo, userHasTeamsSubscription } = useAuth();
    const teamApi = useTeam();

    const requestUrl = `/api/missions/team/${teamId}/active`;

    const getActiveMissions = async () => {
        let response;
        if (isDemo || !userHasTeamsSubscription) {
            response = (
                await import("src/scenes/teams/dashboard/mock-data/team-active-missions-mock-data")
            ).default;
        } else {
            response = await request(requestUrl, {
                method: "GET",
            });
        }
        setActiveMissions(response);
    };

    React.useEffect(() => {
        getActiveMissions();
    }, []);

    return (
        <>
            <MissionsAccordion
                handleModalChange={() => setIsMissionModalOpen(!isMissionsModalOpen)}
                isDemo={isDemo}
                teamId={teamId}
                teamName={teamApi && teamApi.data && teamApi.data.name}
                isMissionsDeleteModalOpen={isMissionsDeleteModalOpen}
                setIsMissionsDeleteModalOpen={setIsMissionDeleteModalOpen}
                setToDeleteId={setToDeleteId}
                setToDeleteKey={setToDeleteKey}
                activeMissions={activeMissions}
            />
            <TeamMissionDeleteModal
                teamId={teamId}
                missionId={toDeleteId}
                missionKey={toDeleteKey}
                open={isMissionsDeleteModalOpen}
                getActiveMissions={getActiveMissions}
                handleClose={() => setIsMissionDeleteModalOpen(false)}
            />
        </>
    );
};

export default TeamMissionsTemplate;
